{
  "carrierLabel": "شركة الناقل",
  "searchPlaceholder": "البحث بالاسم",
  "selectAsCarrier": "تحديد \"{name}\" كناقل",
  "typeToSearch": "اكتب للبحث عن شركة"
}
